import { toast } from "sonner";

import CustomToast from "./CustomToast";
import type { ToastType } from "./CustomToast.types";

export const displayMessage = (message: string, type: ToastType) => {
  toast.custom(() => <CustomToast message={message} type={type} />);
};
